var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMaxIls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 34,
    viewBox: "0 0 129 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 0V33.4H43V0H46.1Z",
    fill: "#515769"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7 0V30.3H58.3V33.4H50.6V0H53.7Z",
    fill: "#515769"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 9.8C60 8.9 59.9 8 59.9 7V3.3C59.9 2.6 60.2 1.9 60.9 1.1C61.6 0.4 62.3 0 63 0H66.2C66.9 0 67.6 0.3 68.3 1C69 1.7 69.3 2.4 69.3 3.1V7H66.2V3.2H63V7C63 7.9 63.2 8.8 63.5 9.6C63.7 10.2 64 10.8 64.5 11.5L68.3 17.2C68.8 18 69.1 19.4 69.3 21.2C69.3 21.7 69.3 22.8 69.3 24.7V30.3C69.3 31 69 31.7 68.3 32.4C67.6 33.1 66.9 33.4 66.2 33.4H63C62.3 33.4 61.6 33.1 60.9 32.4C60.2 31.7 59.9 31 59.9 30.3V25.7H63V30.3H66.2V24.7C66.2 22.6 66.2 21.1 66.1 20.4C66 19.6 65.7 18.9 65.2 18.1L61.4 12.2C60.8 11.4 60.4 10.6 60.2 9.8Z",
    fill: "#515769"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9 0V33.4H73.8V0H76.9Z",
    fill: "#515769"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9 30.3H83V33.4H79.9V30.3Z",
    fill: "#515769"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3 33.4V18.1H89.1V33.4H86V0H92.3C93 0 93.7 0.3 94.4 1C95.1 1.7 95.4 2.4 95.4 3.1V15C95.4 15.3 95.3 15.6 95 16C94.7 16.3 94.4 16.6 94 16.8C94.4 17 94.8 17.2 95 17.5C95.2 17.8 95.4 18.2 95.4 18.6V33.5H92.3V33.4ZM89.1 15H92.3V3.2H89.1V15Z",
    fill: "#515769"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106 0C106.7 0 107.4 0.3 108.1 1C108.8 1.7 109.1 2.4 109.1 3.1V33.3H106V18.1H102.8V33.4H99.7V3.2C99.7 2.5 100 1.8 100.7 1.1C101.4 0.4 102.1 0.1 102.8 0.1H106V0ZM102.8 15H106V3.2H102.8V15Z",
    fill: "#515769"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.8 0V33.4H113.7V0H116.8Z",
    fill: "#515769"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.4 0V30.3H129V33.4H121.3V0H124.4Z",
    fill: "#515769"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9 33.5H10.5C8.9 33.5 7.6 32.2 7.6 30.6V25.9H2.9C1.3 25.9 0 24.6 0 23V2.9C0 1.3 1.3 0 2.9 0H30.8C32.4 0 33.7 1.3 33.7 2.9V30.5C33.8 32.2 32.5 33.5 30.9 33.5ZM11.2 29.8H30.1V3.6H3.6V22.1H7.5V10.6C7.5 9 8.8 7.7 10.4 7.7H23.2C24.8 7.7 26.1 9 26.1 10.6V22.8C26.1 24.4 24.8 25.7 23.2 25.7H11.2V29.8ZM11.2 22.2H22.6V11.4H11.2V22.2Z",
    fill: "#4977E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMaxIls);
export default __webpack_public_path__ + "static/media/logoMaxIls.cfa3229b7d6cc42648c3db267cf4b56d.svg";
export { ForwardRef as ReactComponent };